import angular from 'angular';
import { routes } from './routes';
import { react2angular } from 'react18-react2angular';
import { useContext } from '@components';
import OblerOIListView from './oi/list';
import OblerOIDetailsView from './oi/details';
import OblerProcessosDetailsView from './processos/details';
import OblerProcessosCreateView from './processos/create';
import OblerProcessosagendarView from './processos/visit';
import OblerEncomendasListView from './encomendas/list';
import OblerProcessosListView from './processos/list';
import { OblOiService } from './oi/service';
import { OblProcessoService } from './processos/service';
import { OblEncomendaService } from './encomendas/service';
import { OblInteracaoService } from './interacoes/service';
import OblImporterController from './processos/list/import/controller';
import OblerVisitasListView from './interacoes/visitas';
import OblerOrcamentosListView from './interacoes/orcamentos';
export default angular
    .module('app.obler.2_5', [])
    .config(routes)
    .controller('OblImporterController', OblImporterController)
    .service('OblOiService', OblOiService)
    .service('OblProcessoService', OblProcessoService)
    .service('OblInteracaoService', OblInteracaoService)
    .service('OblEncomendaService', OblEncomendaService)
    .component('oblerOiList', react2angular(useContext.use(OblerOIListView), [], ['$state', 'UIService', 'OblOiService']))
    .component('oblerOiDetails', react2angular(useContext.use(OblerOIDetailsView), [], ['$state', 'UIService', 'OblOiService']))
    .component('oblerProcessosList', react2angular(useContext.use(OblerProcessosListView), [], ['$state', 'UIService', 'OblProcessoService']))
    .component('oblerProcessosDetails', react2angular(useContext.use(OblerProcessosDetailsView), [], ['$state', 'UIService', 'OblProcessoService']))
    .component('oblerProcessosCreate', react2angular(useContext.use(OblerProcessosCreateView), [], ['$state', 'UIService', 'OblProcessoService']))
    .component('oblerProcessosAgendar', react2angular(useContext.use(OblerProcessosagendarView), [], ['$state', 'UIService']))
    .component('oblerEncomendasList', react2angular(useContext.use(OblerEncomendasListView), [], ['$state', 'UIService', 'OblEncomendaService']))
    .component('oblerVisitasList', react2angular(useContext.use(OblerVisitasListView), [], ['$state', 'UIService', 'OblInteracaoService']))
    .component('oblerOrcamentosList', react2angular(useContext.use(OblerOrcamentosListView), [], ['$state', 'UIService', 'OblInteracaoService'])).name;
